import {Combination} from "@beeldit/ecommerce/combinations/models/Combination";
import {SuperOrder} from "@beeldit/ecommerce/super-orders/models/SuperOrder";

export class Shipment {
    public id: number;
    public code: string;
    public label: string;
    public status: number;
    public status_name: string;
    public tracking_url: string;
    public order_id: number;
    public created_at: string;
    public updated_at: string;    

    constructor() {
        this.id = 0;
        this.code = '';
        this.label = '';
        this.status = 0;
        this.status_name = '';
        this.tracking_url = '';
        this.order_id = 0;
        this.created_at = '';
        this.updated_at = '';
    }
}

export class OrderLine {
    public id: number;
    public reference: string;
    public combination_id: number;
    public combination: Combination;
    public order_id: number;
    public quantity: number;
    public total_price: number;
    public unit_price: number;
    public net_price: number;
    public tax: number;
    public discount: number;
    public created_at: string;
    public updated_at: string;
    public deleted_at: string;
    public commission_amount: number;

    constructor() {
        this.id = 0;
        this.reference = '';
        this.combination_id = 0;
        this.combination = new Combination();
        this.order_id = 0;
        this.quantity = 0;
        this.total_price = 0;
        this.unit_price = 0;
        this.net_price = 0;
        this.tax = 0;
        this.discount = 0;
        this.created_at = '';
        this.updated_at = '';
        this.deleted_at = '';
        this.commission_amount = 0;
    }
}

export class Order {

    public static PENDING_STATUS = 1;
    public static PAYED_STATUS = 2;
    public static IN_PREPARATION = 3;
    public static MANAGING_SHIPMENT = 4;
    public static IN_TRANSIT = 5;
    public static DELIVERED = 6;
    public static CANCELLED = 7;

    public id: number;
    public reference: string;
    public status: number;
    public commerce_price: number;
    public subtotal_amount: number;
    public producer_id: number;
    public producer_type: string;
    public super_order_id: number;
    public super_order: SuperOrder|null;
    public pickup_address: any;
    public order_lines: OrderLine[];
    public shipment: Shipment|null;
    public invoice_path: string;
    public shipping_amount: number;
    public shipping_tax: number;

    public created_at: string;
    public updated_at: string;
    public deleted_at: string;


    constructor() {
        this.id = 0;
        this.reference = '';
        this.status = 1; // Pending
        this.commerce_price = 0;
        this.subtotal_amount = 0;
        this.producer_id = 0;
        this.producer_type = '';
        this.super_order_id = 0;
        this.super_order = null;
        this.pickup_address = {};
        this.order_lines = [];
        this.shipment = null;
        this.invoice_path = '';
        this.shipping_amount = 0;
        this.shipping_tax = 0;
        this.created_at = '';
        this.updated_at = '';
        this.deleted_at = '';
    }
}
